import { render, staticRenderFns } from "./AutomobileManufacturing.vue?vue&type=template&id=0cec3aa6&scoped=true&"
import script from "./AutomobileManufacturing.vue?vue&type=script&lang=js&"
export * from "./AutomobileManufacturing.vue?vue&type=script&lang=js&"
import style0 from "./AutomobileManufacturing.vue?vue&type=style&index=0&id=0cec3aa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec3aa6",
  null
  
)

export default component.exports